import { cn } from '@werkstatt/utils';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  fullScreen?: boolean;
}

export const LoadingSpinner = ({
  size = 'md',
  className,
  fullScreen = false
}: LoadingSpinnerProps) => {
  const sizeClasses = {
    sm: 'h-4 w-4 border-2',
    md: 'h-8 w-8 border-2',
    lg: 'h-12 w-12 border-3',
    xl: 'h-16 w-16 border-4',
  };

  const spinner = (
    <div className={cn('inline-block animate-spin rounded-full border-automotive-orange border-t-transparent', sizeClasses[size], className)} role="status" aria-label="Loading">
      <span className="sr-only">Lädt...</span>
    </div>
  );

  if (fullScreen) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-background/80 backdrop-blur-sm z-50">
        <div className="text-center">
          {spinner}
          <p className="mt-2 text-sm text-muted-foreground">Lädt...</p>
        </div>
      </div>
    );
  }

  return spinner;
};
